var render = function render(){var _vm=this,_c=_vm._self._c;return _c('text-input',{attrs:{"type":"area","rows":_vm.rows,"label":_vm.label,"disabled":_vm.disabled}})
}
var staticRenderFns = []

export { render, staticRenderFns }